import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {initializePaddle, Paddle} from "@paddle/paddle-js";
import {PADDLE_CLIENT_TOKEN, PADDLE_ENV} from "../../../pricing";


const Context = createContext<Paddle|undefined>(undefined)

export default function PaddleContext(props: { children: ReactNode }) {
    const [paddle, setPaddle] = useState<Paddle>();

    useEffect(() => {
        initializePaddle({
            environment: PADDLE_ENV,
            token: PADDLE_CLIENT_TOKEN,
            checkout: {
                settings: {
                    successUrl: `${window.location.origin}/account/?msg=sub_success`,
                }
            }
        }).then((paddleInstance?: Paddle) => {
            if (paddleInstance) {
                setPaddle(paddleInstance);
            }
        })
    }, []);

    return <Context.Provider value={paddle}>
        {props.children}
    </Context.Provider>
}

export const usePaddle = () => useContext(Context)